const horseId = (horseOrId) => (typeof horseOrId === 'object' ? horseOrId?.id : horseOrId)

// Ids come as numbers from the API and as strings from a route; a missing id matches nothing.
export const isSameHorse = (horseOrId, otherHorseId) => {
    const candidateId = horseId(horseOrId)

    return (
        candidateId !== null &&
        candidateId !== undefined &&
        otherHorseId !== null &&
        otherHorseId !== undefined &&
        String(candidateId) === String(otherHorseId)
    )
}

export const isPrimaryHorse = (horseOrId, primaryHorseId) => isSameHorse(horseOrId, primaryHorseId)

/**
 * Pins the primary horse without changing the relative order of the other
 * horses or mutating the source array.
 */
export const primaryHorseFirst = (horses, primaryHorseId) => {
    if (!Array.isArray(horses) || horses.length < 2) return horses

    const primaryIndex = horses.findIndex((horse) => isPrimaryHorse(horse, primaryHorseId))
    if (primaryIndex <= 0) return horses

    return [horses[primaryIndex], ...horses.slice(0, primaryIndex), ...horses.slice(primaryIndex + 1)]
}
